import React from "react";
import { motion } from "framer-motion";
import { InfoCircle, Star, Flag } from "iconsax-react";
import "./aboutPage.css";
import Navbar from "../../components/Navbar";
import WhatsAppFloatButton from "../../components/DialMenu/WhatsappFloatButton";

const AboutPage = () => {
  return (
    <>
      <Navbar />
      <motion.div
        className="about-page min-h-screen text-[#5c4033] font-serif p-8 flex flex-col items-center pt-20"
        style={{
          backgroundImage: 'url("/gms.png")',
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          backgroundColor: "#fff",
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h1 className="text-3xl font-bold mb-5 drop-shadow-lg">About Us</h1>

        <div className="about-card-container w-full max-w-4xl flex flex-col space-y-8 p-4 bg-white/70 rounded-xl">
          {/* Card Latar Belakang */}
          <motion.div
            className="about-card w-full p-2 space-y-4 border-l-4 border-[#5c4033] flex items-start gap-4"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <InfoCircle size="32" color="#5c4033" />
            <div>
              <h2 className="text-lg font-semibold mb-2">Background</h2>
              <ul className="list-disc list-inside text-sm space-y-1">
                <li>
                  Bermodal pengalaman bisnis para pendiri sejak tahun 2017,
                  akhirnya PT Gema Mitra Suksesindo (GMS) berdiri pada tahun
                  2023.
                </li>
                <li>
                  Berkomitmen untuk selalu memberikan pelayanan yang terbaik
                  untuk memenuhi semua kebutuhan customer.
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Card Mission */}
          <motion.div
            className="about-card w-full p-2 space-y-4 border-l-4 border-[#5c4033] flex items-start gap-4"
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <Flag size="32" color="#5c4033" />
            <div>
              <h2 className="text-lg font-semibold mb-2">Mission</h2>
              <ul className="list-disc list-inside text-sm space-y-1">
                <li>
                  Membantu customer dalam pembangunan, pemeliharaan, dan
                  efisiensi laboratorium.
                </li>
                <li>Memberikan pelayanan jasa dan bahan-bahan terbaik.</li>
              </ul>
            </div>
          </motion.div>

          {/* Card Vision */}
          <motion.div
            className="about-card w-full p-2 space-y-4 border-l-4 border-[#5c4033] flex items-start gap-4"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <Star size="32" color="#5c4033" />
            <div>
              <h2 className="text-lg font-semibold mb-2">Vision</h2>
              <p className="text-sm">
                Menjadi perusahaan profesional yang bisa memenuhi berbagai
                kebutuhan laboratorium customer.
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
      <WhatsAppFloatButton />
    </>
  );
};

export default AboutPage;
